"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisualSettingsButton = void 0;
const preact_1 = require("preact");
const typestyle_1 = require("typestyle");
const Controls_style_1 = require("../../Controls.style");
const style_1 = require("./style");
class VisualSettingsButton extends preact_1.Component {
    constructor(props) {
        var _a, _b, _c;
        super(props);
        this.toggle = () => this.setState({ isOpen: !this.state.isOpen });
        this.toggleTrails = () => {
            const trailsVisible = !this.state.trailsVisible;
            this.props.game.setTrailVisible(trailsVisible);
            this.setState({ trailsVisible });
        };
        this.setTrailSize = (event) => {
            const trailSize = parseFloat(event.target.value);
            this.props.game.setTrailSize(trailSize);
            this.setState({ trailSize });
        };
        this.setMarker = (markerModel) => {
            this.props.game.setPlayerMarkerModel(markerModel);
            this.setState({ markerModel });
        };
        this.setSensitivity = (event) => {
            const sensitivity = parseFloat(event.target.value);
            this.props.game.mouseSensitivity = sensitivity;
            this.setState({ sensitivity });
        };
        const trails = props.game.replayTrails;
        this.state = {
            isOpen: false,
            trailsVisible: (_a = trails === null || trails === void 0 ? void 0 : trails.trailVisible) !== null && _a !== void 0 ? _a : true,
            trailSize: (_b = trails === null || trails === void 0 ? void 0 : trails.trailSize) !== null && _b !== void 0 ? _b : 2,
            markerModel: (_c = trails === null || trails === void 0 ? void 0 : trails.playerMarkerModel) !== null && _c !== void 0 ? _c : 'box',
            sensitivity: props.game.mouseSensitivity
        };
    }
    render() {
        return (0, preact_1.h)("div", { class: style_1.VisualSettingsButtonStyle.visuals },
            (0, preact_1.h)("div", { class: (0, typestyle_1.classes)(Controls_style_1.ControlsStyle.button, style_1.VisualSettingsButtonStyle.button), title: "Camera and replay settings", onClick: this.toggle }, "\u2699"),
            (0, preact_1.h)("div", { class: this.state.isOpen ? style_1.VisualSettingsButtonStyle.panelOpen : style_1.VisualSettingsButtonStyle.panel },
                (0, preact_1.h)("span", { class: style_1.VisualSettingsButtonStyle.title }, "Camera"),
                (0, preact_1.h)("label", { class: style_1.VisualSettingsButtonStyle.slider },
                    (0, preact_1.h)("span", null, "Sensitivity"),
                    (0, preact_1.h)("input", { type: "range", min: "0.1", max: "5", step: "0.1", value: this.state.sensitivity, onInput: this.setSensitivity }),
                    (0, preact_1.h)("b", null, this.state.sensitivity.toFixed(1))),
                (0, preact_1.h)("span", { class: style_1.VisualSettingsButtonStyle.title }, "Replay visuals"),
                (0, preact_1.h)("span", { class: this.state.trailsVisible ? style_1.VisualSettingsButtonStyle.itemSelected : style_1.VisualSettingsButtonStyle.item, onClick: this.toggleTrails },
                    "3D trails: ",
                    this.state.trailsVisible ? 'On' : 'Off'),
                (0, preact_1.h)("label", { class: style_1.VisualSettingsButtonStyle.slider },
                    (0, preact_1.h)("span", null, "Trail size"),
                    (0, preact_1.h)("input", { type: "range", min: "1", max: "10", step: "0.5", disabled: !this.state.trailsVisible, value: this.state.trailSize, onInput: this.setTrailSize }),
                    (0, preact_1.h)("b", null, this.state.trailSize.toFixed(1))),
                (0, preact_1.h)("span", { class: style_1.VisualSettingsButtonStyle.title }, "Player position"),
                ['box', 'capsule', 'off'].map(model => (0, preact_1.h)("span", { class: this.state.markerModel === model ? style_1.VisualSettingsButtonStyle.itemSelected : style_1.VisualSettingsButtonStyle.item, onClick: () => this.setMarker(model) }, model === 'box' ? 'Box hitbox' : model === 'capsule' ? 'Capsule' : 'Off'))));
    }
}
exports.VisualSettingsButton = VisualSettingsButton;
